import React from 'react';
import './profile-strip.m.css';

const ProfileStrip = () => {
  return (
    <div styleName="profile-wrapper">
      <div styleName="profile-section">
        <div styleName="title">
          <img src="/icons/sunset-logo-gradient.svg" width="20px" height="20px" alt="sun-logo" />
          Your Morning Catch-up is Ready
        </div>
        <div styleName="sub-title">
          <Icon path={mdiPlayCircle} size="20px" color="var(--petrol-blue)" />
          <div styleName="name">Your Briefing</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileStrip;
